import React from "react";
import {
  Search,
  BarChart3,
  MousePointerClick,
  Megaphone,
  PenTool,
  Share2,
  Mail,
  Globe
} from "lucide-react";

const services = [
  {
    icon: Search,
    title: "SEO Optimization",
    desc: "Improve Google ranking and get organic traffic growth."
  },
  {
    icon: MousePointerClick,
    title: "Google Ads",
    desc: "High-converting paid campaigns for instant leads."
  },
  {
    icon: Megaphone,
    title: "Social Media Marketing",
    desc: "Grow brand awareness on Instagram, Facebook & more."
  },
  {
    icon: PenTool,
    title: "Graphic Design",
    desc: "Creative visuals, banners, and brand identity design."
  },
  {
    icon: Share2,
    title: "Social Media Management",
    desc: "Daily posting, engagement, and page handling."
  },
  {
    icon: Mail,
    title: "Email Marketing",
    desc: "Automated email campaigns to convert customers."
  },
  {
    icon: BarChart3,
    title: "Analytics & Reporting",
    desc: "Track performance and optimize marketing strategy."
  },
  {
    icon: Globe,
    title: "Website Marketing",
    desc: "Improve website conversion and online presence."
  }
];

function Services() {
  return (
    <section className="relative py-16 px-6 bg-[#f8f8f8] dark:bg-[#050505] overflow-hidden">

      {/* BACKGROUND EFFECTS */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

     
      {/* CONTENT */}
      <div className="relative z-10 max-w-7xl mx-auto">

  <div className="text-center mb-12 md:mb-16">
                  <h2 className="myheading text-3xl md:text-5xl text-center">
                Our Digital Marketing {" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
           Services
            </span>
          </h2>
   <p className="myparagraph text-gray-500">
Complete growth solutions to scale your business online.</p>
      </div>
      

        {/* GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">

          {services.map((item, i) => (
            <div
              key={i}
              className="group p-6 rounded-2xl bg-white/80 dark:bg-[#111]/80 backdrop-blur-md border border-gray-100 dark:border-gray-800 hover:shadow-xl transition-all duration-300"
            >
              {/* ICON */}
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-orange-50 dark:bg-orange-900/20 mb-4 group-hover:scale-110 transition">
                <item.icon className="w-6 h-6 text-primary" />
              </div>

              {/* TITLE */}
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                {item.title}
              </h3>

              {/* DESC */}
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-2 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
}

export default Services;